<ras-page>
	<main>
		<h1>Refer a friend</h1>
		<p class="lead">
			Refer a friend and you get <b>R500</b> off future rent. 
			Simply let us have your friend’s details and we will do the rest.
		</p>

		<form [ngClass]="{'show-invalid': show_invalid}" id="contact-form">
			<h2>Your details:</h2>
			<p>
				<label class="required">At which Rent-A-Store branch are you a customer?</label>
				<ras-dropdown [options]="locations" label="name" [(value)]="location" [valid]="!show_invalid || !!location"></ras-dropdown>
				<span class="validation" *ngIf="show_invalid && !location">Please choose a location</span>
			</p>
			<p>
				<label>Your first name</label>
				<input [disabled]="busy" name="name" [(ngModel)]="name" type="text">
			</p>
			<p>
				<label>Your surname</label>
				<input [disabled]="busy" name="surname" [(ngModel)]="surname" type="text" type="text">
			</p>
			<p>
				<label>Your unit number</label>
				<input [disabled]="busy" name="unit_number" [(ngModel)]="unit_number" type="text" type="text">
			</p>

			<h2>Your friend’s details:</h2>

			<p>
				<label>Friend's first name</label>
				<input [disabled]="busy" name="friend_name" [(ngModel)]="friend_name" type="text">
			</p>
			<p>
				<label>Friend's surname</label>
				<input [disabled]="busy" name="friend_surname" [(ngModel)]="friend_surname" type="text" type="text">
			</p>
			<p>
				<label class="required">Friend's contact number</label>
				<input [disabled]="busy" name="friend_cell" [(ngModel)]="friend_cell" type="text" type="text" [ngClass]="{invalid: !valid.sa_cell_number(friend_cell)}">
				<span class="validation" *ngIf="show_invalid && !valid.sa_cell_number(friend_cell)">Please provide a valid SA cell number</span>
			</p>
			<p>
				<label class="required">Friend's email address</label>
				<input [disabled]="busy" name="friend_email" [(ngModel)]="friend_email" type="text" type="text" [ngClass]="{invalid: !valid.email(friend_email)}">
				<span class="validation" *ngIf="show_invalid && !valid.email(friend_email)">Please provide an email address</span>
			</p>
			<p>
				<button *ngIf="!busy" type="button" (click)="send_message()">Submit</button>
				<button *ngIf="busy" disabled type="button" (click)="send_message()">Sending</button>
			</p>
		</form>

		<div>
			<h2>T's &amp; C's of tenant referral program</h2>

			<ul>
				<li>The offer is valid for current RENT-A-STORE customers only.</li>
				<ul>
					<li>You may refer as many friends, family, colleagues or strangers as you like.</li>
					<li>You may not refer yourself when transferring or taking up additional units.</li>
					<li>You may refer across all RENT-A-STORE branches.</li>
				</ul>
				<li>A once off credit will be passed to your account for each unit rented by your friend.</li>
				<li>Your credit will be passed in the month following signature of lease and initial payment by your friend.</li>
				<li>The offer is not transferable or redeemable for cash.</li>
				<li>There is no expiry date on the offer, but RENT-A-STORE reserves the right to cancel or withdraw the offer at any time.</li>
			</ul>
		</div>

	</main>
</ras-page>

<ras-popup *ngIf="form_sent" (close)="form_sent = false">
	<p>Thank you. Your referral has been sent.</p>
</ras-popup>

<ras-popup *ngIf="form_error" (close)="form_error = false" error="true">
	<p>Sorry, it seems that there is a problem sending your referral right now. Please try again later.</p>
</ras-popup>
